module.exports = __webpack_public_path__ + "img/bouquet_03.a2201c56.jpg";